// progress bars
 function progressBar(className,countTo){
    jQuery(className).each(function() {
    let percent = jQuery(this).attr('data-value');
     percent =  countTo;
  if(percent > 100){
    percent = 100;
  } 
  jQuery(this).animate({width: percent+'%' }, 2000);
});
    }


  // count number
   function numberCounter(className){
     jQuery(className).each((i, el) => {
console.log(el);
    var $counter = jQuery(el);
    if (!$counter.isInViewport() || $counter.data('animation-started'))
      return;

    $counter.data('animation-started', true).prop('Counter', 0).animate({
      Counter: $counter.text()
    }, {
      duration: 2000,
      easing: 'swing',
      step: function(now) {
        $counter.text(Math.ceil(now));
      }
    });
  });
  }

jQuery.fn.isInViewport = function() {
  var elementTop = jQuery(this).offset().top;
  var elementBottom = elementTop + jQuery(this).outerHeight();
  var viewportTop = jQuery(window).scrollTop();
  var viewportBottom = viewportTop + jQuery(window).height();
  return elementTop < viewportBottom;
};



jQuery(document).ready(function(){ 
 jQuery(window).scroll(function(){
    // if(jQuery(window).scrollTop() >= jQuery('.compression_product').offset().top + jQuery('.compression_product').height() || jQuery(window).scrollTop() > jQuery('.compression_product').offset().top)
     //  {
     //      numberCounter('.pressure-section-compression .progeres-box.first-bar .heading-gradient h2');
     //       progressBar(".pressure-section-compression .progeres-box.first-bar .progressbar .bar","100");
     //       progressBar(".pressure-section-compression .progeres-box.second-bar .progressbar .bar","70");
     // }
      });

  //
  //  jQuery(window).scroll(function(){
  // if(jQuery(window).scrollTop() >= jQuery('.pressure-section-compression').offset().top + jQuery('.pressure-section-compression').height() || jQuery(window).scrollTop() > jQuery('.pressure-section-compression').offset().top)
  //     {
  //    // console.log('here');
  //     numberCounter('.pressure-section-compression .content-progress-bar .heading-gradient h2 span');
  //     progressBar(".pressure-section-compression .progeres-box.first-bar .progressbar .bar","100");
  //     progressBar(".pressure-section-compression .progeres-box.second-bar .progressbar .bar","70");
  //    }

  //     if(jQuery(window).scrollTop() >= jQuery('.pressure-section-compression .content-progress-bar').offset().top + jQuery('.pressure-section-compression .content-progress-bar').height() || jQuery(window).scrollTop() > jQuery('.pressure-section-compression .content-progress-bar').offset().top){
  //        numberCounter('.compress-cycle-section .content-progress-bar .heading-gradient h2');
  //       // progressBar(".pressure-section-compression .progeres-box.first-bar .progressbar .bar","100");
  //       //progressBar(".pressure-section-compression .progeres-box.second-bar .progressbar .bar","70");
  //     }
  //         //for compress section
  //      if(jQuery(window).scrollTop() >= jQuery('.compress-cycle-section .content-progress-bar').offset().top + jQuery('.compress-cycle-section .content-progress-bar').height() || jQuery(window).scrollTop() > jQuery('.compress-cycle-section .content-progress-bar').offset().top){
  //         numberCounter('.dynamic-comrpession-section .mob_heading .heading-gradient h2 ');
  //       }
  //       //for chamber-section-compression
  //       if(jQuery(window).scrollTop() >= jQuery('.visual-compression-section .content-progress-bar').offset().top + jQuery('.visual-compression-section .content-progress-bar').height() || jQuery(window).scrollTop() > jQuery('.visual-compression-section .content-progress-bar').offset().top){
  //         numberCounter('.chamber-section-compression .content-progress-bar .heading-gradient h2 ');
  //       }
  //  });
  
  });
